import React from 'react'
import Retour from '../components/Retour'

function Memory() {
  return (
    <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Dans un monde futuriste où l’eau se fait rare, Noria est devenue la Maîtresse du thé de son village, suivant à la lettre les traditions héritées de son défunt père. Elle détient également un secret bien gardé depuis des générations. La jeune femme doit faire appel à sa force tranquille pour la guider à travers une dangereuse odyssée pour la survie de son peuple.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
  )
}

export default Memory